import { ChangeDetectionStrategy, Component, inject, output, viewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, Validators } from '@angular/forms';
import { Router, UrlTree } from '@angular/router';
import { filter } from 'rxjs';

import { isMenuCollapsed } from '../../helper/menu.helper';
import { FocusService } from '../../services/focus.service';
import { InputComponent } from '../form';

@Component({
  selector: 'dmb-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  imports: [InputComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchComponent {
  private _router = inject(Router);
  private focusService = inject(FocusService);

  readonly searching = output<boolean>();

  public searchString = new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(200)]);

  private theInput = viewChild(InputComponent);

  constructor() {
    this.searchString.valueChanges.pipe(takeUntilDestroyed()).subscribe(() => this.untouchedWhenEmpty());

    this.focusService.currentFocus
      .pipe(
        takeUntilDestroyed(),
        filter((v) => v === 'search'),
      )
      .subscribe(() => {
        this.theInput()?.elementRef()?.nativeElement.focus();
      });
  }

  untouchedWhenEmpty() {
    if (!this.searchString.getRawValue()) {
      this.searchString.markAsUntouched();
      if (isMenuCollapsed()) {
        this.searching.emit(false);
      }
    }
  }

  public submitSearch(e: Event) {
    e.preventDefault();
    e.stopPropagation();
    if (!this.searchString.valid) {
      console.log(this.searchString.errors);
      return;
    }

    const urlTree: UrlTree = this._router.createUrlTree(['/page/products'], {
      queryParams: {
        phrase: this.searchString.getRawValue(),
        doSearch: 1,
        action: 'search',
        page: 'products', // this.searchType.type,
        'dmb-v3': 1,
      },
    });

    this.searchString.reset();
    this.searching.emit(true);
    return this._router.navigateByUrl(urlTree);
  }
}
